import React, { Children } from 'react';
import { motion } from 'framer-motion';
const problems = [{
  title: 'Cities are not built for knowing your neighbors',
  description: 'Most urban housing optimizes for units, transactions, and privacy — not for the relationships that make daily life feel supported.',
  image: 'https://cdn.magicpatterns.com/uploads/oepcr1ohYnct1ELN5ox1YQ/pasted-image.jpg',
  alt: 'An aerial view of the Mexico City skyline'
}, {
  title: 'Developmental challenges in cities',
  description: 'Kids have fewer safe spaces for unstructured play, mixed-age friendships, and everyday relationships with trusted adults.',
  image: 'https://cdn.magicpatterns.com/uploads/cZUYyF5EHWdKFG8uvxNQ9P/pasted-image.jpg',
  alt: 'A young child sitting on the floor at home looking at a phone'
}, {
  title: 'Loneliness is rising',
  description: 'When home is designed around isolation, civic engagement declines and support networks become harder to maintain.',
  image: 'https://cdn.magicpatterns.com/uploads/55SdZcDCR746xgqcawYGVf/pasted-image.jpg',
  alt: 'A person sitting alone on a park bench at night'
}, {
  title: 'Ownership is out of reach',
  description: 'For many young families, conventional home ownership feels increasingly distant — especially in the neighborhoods where their lives already happen.',
  image: 'https://cdn.magicpatterns.com/uploads/bkvoPkhSFcNJUkP3MUUWUB/pasted-image.jpg',
  alt: 'An assortment of coins including Mexican pesos spread on a surface'
}];
export function ProblemSection() {
  return <section id="about" className="py-24 px-6 md:px-12 bg-cream" data-id="element-141">
      <div className="max-w-7xl mx-auto" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-20 max-w-3xl" data-id="element-143">
          <h2 className="text-4xl md:text-5xl text-navy mb-6 font-serif tracking-wide" data-id="element-144">
            Modern cities are not built with community in mind.
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-8 gap-y-12" data-id="element-145">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col" data-id="element-146">
              <div className="aspect-square w-full max-w-[240px] overflow-hidden rounded-full mb-6" data-id="element-147">
                <img src={problem.image} alt={problem.alt} className="w-full h-full object-cover" data-id="element-148" />
              </div>
              <h3 className="text-xl font-serif tracking-wide text-navy mb-3" data-id="element-149">
                {problem.title}
              </h3>
              <p className="text-navy/70 text-sm leading-relaxed" data-id="element-150">
                {problem.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}